module.exports = __webpack_public_path__ + "0ad597b5a16e7075b73fe8a71aea0d57.png";


//////////////////
// WEBPACK FOOTER
// ./assets/arrow-down.png
// module id = ygdx
// module chunks = 0